const server = process.env.REACT_APP_G1DOMAIN;
const serverCore = process.env.REACT_APP_SERVER_PRODUCT;



export {
    server,
    serverCore
};